module.exports = __webpack_public_path__ + "static/media/icon-reel-light.d687e8a7.svg";